import { IAutoCheckout } from '../../../interfaces';

export type TPolicyCheckout = {
  policyCheckout: IAutoCheckout | null;
};

export function getCheckoutProps({ policyCheckout }: TPolicyCheckout) {
  const monthlyBill = policyCheckout?.billing_amounts.find(
    (bill) => bill.billing_cadence === 'monthly'
  );
  return {
    updatedMonthlyBill: monthlyBill,
    updatedPrice: parseFloat(monthlyBill?.total || '0'),
    paymentDue: parseFloat(policyCheckout?.amount_due || '0'),
  };
}
